var t=(e=>(e[e.footer=1]="footer",e[e.privacy_message=2]="privacy_message",e[e.form_privacy_message=3]="form_privacy_message",e))(t||{});export{t as a};
